// The Firebase web app config. Public by design (it ships in the browser
// bundle); the server also uses the API key for Identity Toolkit REST calls.
export const firebaseConfig = {
  apiKey: "AIzaSyBAH1AdlzZs6l6reHMi_ReoigY7fNgLwbU",
  authDomain: "uc-data-portal.firebaseapp.com",
  projectId: "uc-data-portal",
}
